import Superscript from "@/components/ui/superscript";
export const keyFacts = [
  {
    title: <>Number of internal migrants</>,
    description: (
      <>
        27 million internal migrants
        <Superscript
          path="https://webapi.bps.go.id/download.php?f=ghlSZORxeO0jlkk6mELZqkNIdU42NXk2SnhkQmRnTHlwVXp6L2xLN1VkMXFLUnJiSVJuVGx3QjhtbjN6WDdyQnErTFhwVjI1dkh6RE1hTWgrV3NzTnA4enB0aFhVYXlKY0U1NmdPazlUSTdZb0plS09rd3k0MWt2YmthTzJlOHVXcjQ0NTRtYjFEbnJiSThCMElmNTFWeU1PNUE2bW9CWktKcnI5QmNwSVZQZmVlV0lUZ1M1NFlodzAvM0JoaiswdlZrUVdLRytOc3Z6amNDSmZ2cXMyTStkWXBweFBmcjMrK2lSWUljUWFqd3g2dXFwb3dSZTRZZHlEZ3pob3NQMG5Dck0zcWQrSVM3MVRhbUxLUWlDM3RMcnRWZ1ZGSU5ZdnlaOGVCcFpiYXdBelF1R2xxK3VWYVpUUzQ1bFYwVE9JazdPMFdMaTN5aGVuVHJN&_gl=1*7ndu17*_ga*MTc3NTM5MzM3OS4xNzI1NDQwNTE2*_ga_XXTTVXWHDB*MTcyNTQ0MDUxNS4xLjAuMTcyNTQ0MDUxNS4wLjAuMA.."
          index="1"
        />{" "}
      </>
    ),
    icon: "/images/icons/migration.png",
  },
  {
    title: <>Migration trends</>,
    description: (
      <>
        Rural to urban migration is the most dominant pattern of migration.
        <Superscript
          path="https://unesdoc.unesco.org/ark:/48223/pf0000389470"
          index="2"
        />
        <Superscript
          path="https://indonesia.unfpa.org/sites/default/files/pub-pdf/FA_Isi_BUKU_Monograph_Internal_Migration_ENG.pdf"
          index="3"
        />{" "}
      </>
    ),
    icon: "/images/icons/urbanization.png",
  },
  {
    title: <>Key destination areas</>,
    description: (
      <>
        Jawa, Sumatra and Kalimantan
        <Superscript
          path="https://indonesia.unfpa.org/sites/default/files/pub-pdf/FA_Isi_BUKU_Monograph_Internal_Migration_ENG.pdf"
          index="4"
        />
      </>
    ),
    icon: "/images/icons/destination (2).png",
  },
  {
    title: (
      <>
        Prominent sectors of employment for migrants{" "}
        <Superscript
          path="https://indonesia.unfpa.org/sites/default/files/pub-pdf/FA_Isi_BUKU_Monograph_Internal_Migration_ENG.pdf"
          index="5"
        />
      </>
    ),
    description: <>Services, Industry and Agriculture.</>,
    icon: "/images/icons/job.png",
  },
];
export const climateImpacts = [
  {
    description: (
      <>
        110 million Indonesians across 60 cities of the country are exposed to
        the impacts of climate change, with the poor being highly vulnerable.{" "}
        <Superscript
          path="https://www.adb.org/sites/default/files/publication/700411/climate-risk-country-profile-indonesia.pdf"
          index="6"
        />{" "}
        Current estimates for climate migrants in the country are unavailable.
      </>
    ),
    icon: "/images/icons/migration.png",
  },
  {
    description: (
      <>
        Indonesia’s Jakarta is a well-known example of the environmental impacts
        of rapid urbanisation. It has been projected to be the fastest-sinking
        city globally{" "}
        <Superscript
          path="https://www.indiatoday.in/world/story/jakarta-sinking-indonesia-changes-capital-nusantara-explained-1902290-2022-01-20"
          index="7"
        />
        , and is estimated to sink 95% by 2050.{" "}
        <Superscript
          path="https://www.indonesiawaterportal.com/news/the-effect-of-climate-change-on-mass-migration.html"
          index="8"
        />{" "}
        Such a catastrophic event could lead to large-scale migration out of the
        city
      </>
    ),
    icon: "/images/icons/climate-change.png",
  },
  {
    description: (
      <>
        Top three impacts at source on livelihoods in Indonesia are crop loss
        (58%), job loss (37%) and wage loss (28%), and household impacts are
        food insecurity (57%), lost access to water and sanitation (37%) and
        health issues (34%). (Sample size - 368)
      </>
    ),
    icon: "/images/icons/impact.png",
  },
  {
    description: (
      <>
        Top three impacts at destination on livelihoods are wage loss (57%) ,
        wage cut (45%) and job loss (31%), and household impacts are health
        issues (63%), transportation routes in/out of migrant locations
        damaged/slowed (28%) and house damage (19%). (Sample size - 662)
      </>
    ),
    icon: "/images/icons/home.png",
  },
];
export const stories = [
  {
    title: "Rising Above Waters: A Migrant's Pursuit to Stability",
    description: "",
    videoPath: "https://youtu.be/bGRWH7AM9ZY",
  },
];

export const partners = [
  {
    link: "https://dfw.or.id/",
    title: "Lorem Ipsum",
    logo: "/images/indonesia/logo-DFW-High-Res.png",
  },
  // {
  //   link: "https://www.forestpeoples.org/index.php/en/partner/palangkaraya-ecological-and-human-rights-studies-progress",
  //   title: "Lorem Ipsum",
  //   logo: "/images/indonesia/fpp-logo-dark.png",
  // },
  {
    link: "https://embunpelangibatam.or.id/",
    title: "Lorem Ipsum",
    logo: "/images/indonesia/YEP-Logo-Icon.png",
  },
  {
    link: "https://yayasansrikandilestari.wordpress.com/",
    title: "Lorem Ipsum",
    logo: "/images/indonesia/logo-srikandi-2.webp",
  },
  // {
  //   link: "https://progresskalimantan.org/",
  //   title: "Lorem Ipsum",
  //   logo: "/images/indonesia/progress.png",
  // },
];

export const seo = {
  slug: "/indonesia",
  metaTitle:
    "Indonesia | People’s Courage International, South & Southeast Asia",
};

export const jsonLd = {
  "@context": "http://www.schema.org",
  "@type": "Organization",
  name: "People’s Courage International",
  description:
    "People’s Courage International is a USA-based not-for-profit organization. Join our charity and help us provide critical support to those in need around the world.",
  address: {
    "@type": "PostalAddress",
    streetAddress: "3206 10th Street NE, Washington",
    addressLocality: "DC",
    postalCode: "20017",
    addressCountry: "USA",
  },
  contactPoint: {
    "@type": "ContactPoint",
    telephone: "+1202-573-8727",
    contactType: "customer support",
  },
};
export const insights = [
  {
    heading:
      "Long-term migration is prevalent in Indonesia as opposed to short-term migration ",
    text: `Indonesia has been experiencing rapid growth in urban areas, with 54% of the population residing there, expected to further increase to 68% by 2050.<sup><a href="https://bangkok.unesco.org/sites/default/files/assets/article/Social and Human Sciences/publications/Brief 3 - Country Brief - Indonesia.pdf" target="_blank" rel="noreferrer">[9]</a></sup> Migration movements in the country are mainly for longer durations as a result of its archipelagic landscape making air travel the most prominent mode of transport however extremely expensive.  As a result, the combination of distant destinations and high travel costs encourage migrants to relocate for longer durations.<sup><a href="https://www.semanticscholar.org/paper/Internal-Migration-in-Indonesia-%3A-Duration-and-Susanti-Damayanti/d587d1b29ebe2e776e36f2c353ff3310bca70109" target="_blank" rel="noreferrer">[10]</a></sup>`,
    image: "/images/indonesia/story-1.webp",
  },
  {
    heading:
      "Due to rapid urbanisation and frequent flooding, Jakarta is predicted to sink 95% by 2050.",
    text: `According to the Global Report on Internal Displacement (GRID 2022), there were 300,000 disasters in Indonesia causing internal displacement in the country. Research has indicated that out migration as a result of the increasing temperature and variation in rainfall will have a greater impact than disasters in the country.<sup><a href="https://www.pnas.org/doi/10.1073/pnas.1317166111" target="_blank" rel="noreferrer">[11]</a></sup> Furthermore, it is important to note that the country has experienced impacts of climate change in destination areas as well. Indonesia’s Jakarta is a well-known example of the environmental impacts of rapid urbanisation. It has been projected to be the fastest-sinking city globally<sup><a href="https://www.indiatoday.in/world/story/jakarta-sinking-indonesia-changes-capital-nusantara-explained-1902290-2022-01-20" target="_blank" rel="noreferrer">[12]</a></sup>, and is estimated to sink 95% by 2050.<sup><a href="https://www.indonesiawaterportal.com/news/the-effect-of-climate-change-on-mass-migration.html" target="_blank" rel="noreferrer">[13]</a></sup> In response, the Indonesian government is planning to shift its capital to Nusantara.`,
    image: "/images/indonesia/story-2.webp",
  },
  {
    heading:
      "The new labour regulations in the country are more focused on investors and reviving the economy post pandemic",
    text: `The Labour Rights Index (2022) highlights the presence of ‘limited access to decent work’ in Indonesia.<sup><a href="https://labourrightsindex.org/lri-2022-documents/lri-2022-final-7-oct.pdf" target="_blank" rel="noreferrer">[14]</a></sup>  Studies have also indicated that compliance with existing laws is limited. For instance, a survey conducted in the garment sector in Asia found a non-compliance rate of 39.1% with the minimum wage regulations in Indonesia.<sup><a href="https://www.ilo.org/wcmsp5/groups/public/---ed_protect/---protrav/---travail/documents/publication/wcms_509532.pdf" target="_blank" rel="noreferrer">[15]</a></sup> Following the pandemic, the labour laws have also undergone significant changes. The government enacted the ‘Omnibus Law’ aimed to attract investors and revive the economy post-pandemic.  However, union members and experts have critiqued that these laws disregard labour rights. For instance, the law granted firms the freedom to exceed government-set limits for working hours and overtime.<sup><a href="https://www.pwc.com/id/en/publications/omnibus/omnibus-flash-2021-04.pdf" target="_blank" rel="noreferrer">[16]</a></sup> Eventually, the court deemed the law unconstitutional and stated that it needed to be amended or replaced.<sup><a href="https://www.reuters.com/world/asia-pacific/indonesia-court-orders-government-amend-controversial-labour-law-2021-11-25/" target="_blank" rel="noreferrer">[17]</a></sup> In December 2022, the Indonesian government issued an emergency regulation to replace the law. However, critics have argued that this new law was not any different from the previous, as majority of its provisions remained unchanged.<sup><a href="https://theconversation.com/indonesias-emergency-labour-regulation-changes-spark-worker-anger-a-year-out-from-election-but-jokowis-government-is-unwavering-197281" target="_blank" rel="noreferrer">[18]</a></sup>`,
    image: "/images/indonesia/story-3.webp",
  },
  {
    heading:
      "Portability constraints in schemes lead to limited access for internal migrants",
    text: `27.8% (excluding health insurance schemes) of the Indonesian population is covered by at least one social security scheme.<sup><a href="https://www.ilo.org/wcmsp5/groups/public/---ed_protect/---soc_sec/documents/publication/wcms_817572.pdf" target="_blank" rel="noreferrer">[19]</a></sup> Migrant workers face significant challenges when accessing schemes at destination locations. Even though social security schemes are portable in Indonesia, several constraints exist. For example, accessing the healthcare insurance scheme outside the registration area has certain conditions leading to inaccessibility for migrants.<sup><a href="https://www.tandfonline.com/doi/full/1 0.1080/23288604.2015.1020642" target="_blank" rel="noreferrer">[20]</a></sup> For other schemes that provide direct government aid, the lack of migrant registries and the ability of local government bodies to keep track of migrants’ current residence has restricted access for them.`,
    image: "/images/indonesia/story-4.webp",
  },
];

export const learnMore = [
  {
    link: "https://bangkok.unesco.org/sites/default/files/assets/article/Social and Human Sciences/publications/Brief 3 - Country Brief - Indonesia.pdf",
    text: "Overview of Internal Migration in Indonesia",
  },
  {
    link: "https://indonesia.unfpa.org/sites/default/files/pub-pdf/FA_Isi_BUKU_Monograph_Internal_Migration_ENG.pdf",
    text: "Internal Migration in Indonesia",
  },
];
